import moment from 'moment';
import FaqController from './FaqController';
import { Settings } from '../common/Settings';

// eslint-disable-next-line no-undef
document.addEventListener('DOMContentLoaded', () => {
  moment.locale(Settings.language());
  const controller = new FaqController();
  controller.Init();    
});
